import React, { useEffect, useState } from "react";
import './AboutModal.css';
import aboutBot from "../../assets/aboutBotPnc.svg";
import { useTranslation } from 'react-i18next';

const AboutModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [animationClass, setAnimationClass] = useState("");

  // Update isMobile state when window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle modal animation classes
  useEffect(() => {
    if (isOpen) {
      setAnimationClass(isMobile ? "modal-slide-up" : "modal-fade-in");
    } else {
      setAnimationClass("");
    }
  }, [isOpen, isMobile]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 modal-overlay">
      <div className={`bg-white rounded-2xl shadow-lg max-w-2xl w-full overflow-hidden aboutPncMain ${animationClass}`}>
        {/* Modal header */}
        <div className="flex justify-between items-center px-[24px] py-[16px] border-b border-gray-200 bg-[#FFF1F1]">
          <h2 className="aboutHeadingPnc">{t('aboutPNC')} </h2>
          <button 
            onClick={onClose}
            className="text-black crossFeedBtnPnc"
          >
            <svg className="svgFeedPnc" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Modal body */}
        <div className="px-6">
          <div className="flex justify-center my-[40px]">
            <div className="w-64 h-32 relative">
              <img src={aboutBot} alt="About Bot" />
            </div>
          </div>
          
          {/* Description */}
          <p className="text-gray-800 descriptionAboutPnc mb-3">
           {t('pncDetails')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;